export default {
  title: 'JLS servis',
  message: {
    login: 'Login',
    logout: 'Logout'
  },
  login: {
    title: 'Login',
    forgottenPassword: 'Forgotten password',
    loginAdAccount: 'Treasury AD',
    loginStandardAccount: 'Standard',
    anonymousAccess: 'Anonymous access'
  },
  user: {
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm password',
    email: 'E-mail',
    firstTimeLogin: 'First time login',
    passwordForgotten: 'Forgot password?',
    passwordResetLinkSent: 'Password reset link has been sent to your email address'
  },
  sidebar: {
    administration: 'Administration',
    manageUsers: 'Manage users',
    createUser: 'Create user',
    registry: 'Registry',
    subscribe: 'Subscribe'
  },
  contextPath: {
    administration: 'Administration',
    table: 'Registry',
    row: 'Row',
    Demo: 'demo',
    Program: 'Program',
    Project: 'Project',
    Position: 'Position',
    ProgramActivity: 'Program activity',
    SubEconomicClassification: 'Sub economic classification',
    SubSourceOfFunding: 'Source of funding',
    Municipality: 'Municipality',
    user: 'User',
    subscribe: 'Subscribe'
  },
  general: {
    phone: 'Phone',
    email: 'E-mail',
    changelog: 'Changelog',
    technicalSupport: 'Technical support'
  },
  bool: {
    yes: 'Yes',
    no: 'No'
  },
  tabulator: {
    ajax: {
      loading: 'Loading', // ajax loader text
      error: 'Error' // ajax error text
    },
    groups: { // copy for the auto generated item count in group header
      item: 'item', // the singular  for item
      items: 'items' // the plural for items
    },
    pagination: {
      page_size: 'Page Size', // label for the page size select element
      first: 'First', // text for the first page button
      first_title: 'First page', // tooltip text for the first page button
      last: 'Last',
      last_title: 'Last Page',
      prev: 'Prev',
      prev_title: 'Prev Page',
      next: 'Next',
      next_title: 'Next Page'
    },
    headerFilters: {
      default: 'filter column...', // default header filter placeholder text
      columns: {
        name: 'filter name...' // replace default header filter text for column name
      }
    },
    emptyTable: 'No informations'
  },
  roles: {
    Role_Administrator: 'Administrator',
    Role_Operator: 'Operator',
    Role_User: 'User',
    Role_Refresh_Token: 'Refresh token',
    Role_Demo: 'Demo table'
  },
  claims: {
    Claim_Admin: 'Administration',
    Claim_User_Revoke: 'Revoke user',
    Claim_User_Review: 'Review user',
    Claim_User_Create: 'Create user',
    Demo_Insert: 'Insert Demo table',
    Demo_Update: 'Update Demo table',
    Demo_Review: 'Review Demo table'
  },
  form: {
    ok: 'OK',
    cancel: 'Cancel',
    submit: 'Submit',
    send: 'Send',
    close: 'Close',
    save: 'Save',
    apply: 'Apply',
    edit: 'Edit',
    warning: 'Warning',
    notification: 'Notification',
    load: 'Load',
    saveToFile: 'Save to file',
    saveToDiagnosticFile: 'Save to diagnostic file',
    saveToClipboard: 'Save to clipboard',
    capsLockOn: 'Caps Lock is on',
    activate: 'Activate',
    revoke: 'Revoke',
    delete: 'Delete',
    exportToCsv: 'Export to csv',
    exportToJson: 'Export to json'
  },
  activation: {
    title: 'User activation',
    success: 'User successfully activated',
    activationSent: 'User activation link has been sent to your email address'
  },
  reset: {
    title: 'Password change',
    success: 'User password set succesfully'
  },
  errors: {
    someErrorsOccuredCheckListBelow: 'Some errors has occurred. Please check the list below',
    token: {
      refreshTokenExpired: 'Refresh token has expired',
      failedToRefreshToken: 'Failed to obtain new access token after refresh'
    }
  },
  autocomplete: {
    completeSedarchMessage: 'Enter the \'{query}\' criterion to satisfy more than {limit} results. Narrow your search criteria or continue your search on {url}',
    urlText: ''
  },
  dataTable: {
    title: 'Data tables',
    name: 'Data table name',
    lobeTables: 'Tables',
    addNewCode: 'Add new',
    subscribe: 'Subscribe',
    filterUrlLabel: 'Filter URL',
    demoAdd: 'Add new demo row',
    dataTableAddRowSuccess: 'New row successfully added',
    dataTableAddRowFailed: 'Failed to add new row',
    positionAdd: 'Add new position',
    failedValidation: 'Validation failed',
    addDataTable: 'Add new registry',
    notDefined: 'Not defined',
    review: 'Review',
    update: 'Update',
    insert: 'Insert',
    history: 'History',
    deleteRowPrompt: 'Are you sure you want to delete this row?',
    chooseAction: 'Choose action',
    insertSingle: 'Insert single',
    insertBulk: 'Insert bulk',
    updateBulk: 'Update bulk',
    returnToPreviousPage: 'Return to previous page',
    jsonInvalidFormat: 'JSON file is not in valid format',
    successfulAdd: 'Successful bulk insert',
    loadErrorTitle: 'Insert bulk file errors',
    errors: {
      validToDatePassed: 'Entered date has passed',
      notNullableColumnNotSet: 'Mandatory field is not set',
      columnDoesNotExists: 'Column does not exists',
      invalidDataType: 'Data taype is not valid',
      notEditableColumnSet: 'Not editable column value is set',
      mustBeString: 'Value must be string'
    }
  },
  dataTables: {
    demo: 'Demo',
    sourceOfFunding: 'Source of funding',
    paymentCode: 'Payment code',
    country: 'Country',
    bank: 'Bank',
    function: 'Function',
    еconomicClassification: 'Economic classification',
    municipality: 'Municipality'
  },
  dataTableColumns: {
    status: 'Status',
    id: 'Id',
    validFrom: 'Valid from',
    validTo: 'Valid to',
    name: 'Name',
    createdDate: 'Created on',
    createdUserName: 'Created by',
    createdUserId: 'Created by',
    version: 'Version',
    lastChangedDate: 'Changed on',
    lastChangedUserId: 'Changed by',
    lastChangedUserName: 'Changed by',
    age: 'Age',
    height: 'Height',
    birthDate: 'Birth date',
    happy: 'Happy',
    profession: 'Profession',
    description: 'Description',
    nameEnglish: 'English name',
    sourceOfTransferId: 'Source of transfer id',
    cashTransfer: 'Cash transfer',
    request104: 'Request 104',
    type: 'Type',
    refunds: 'Refunds',
    nameLatin: 'Latin name',
    countryCode: 'Country code',
    letterCode: 'Letter code',
    swift: 'Swift',
    companyNumber: 'Company number',
    address: 'Address',
    place: 'Place',
    countryId: 'Country',
    domesticBank: 'Domestic bank',
    level: 'Level',
    parentId: 'Parent id',
    exemptFromEnforcedCollection: 'Exempt from enforced collection',
    forEnforcedCollection: 'For enforced collection',
    urgentPayment: 'Urgent payment',
    notForBudget: 'Not for budget',
    territory: 'Territory',
    municipalityPlace: 'Municipality place',
    newMunicipality: 'New municipality',
    municipalityCodeType: 'Municipality code type',
    regionCode: 'Region code',
    regionName: 'Region name',
    cityCode: 'City code',
    cityName: 'City name'
  },
  dataTableValidation: {
    fieldRequired: 'Field is required',
    intRequired: 'Filed must be intereger',
    floatRequired: 'Field must be decimal (use. as decimal separator)'
  },
  dropzone: {
    defaultMessage: 'Drag and drop file',
    allowedFormats: 'Allowed file formats: ',
    unsupportedFile: 'Unsupported file type!',
    tooManyFiles: 'Too many files draged'
  },
  administration: {
    userDetails: 'User details',
    userLogin: 'Username',
    userLoginAd: 'Ad username',
    userName: 'Namе and surname',
    userStatus: 'Status',
    name: 'Name',
    email: 'Email',
    localAdministration: 'Local user management',
    localUserRoles: 'User roles',
    localUserClaims: 'User claims',
    apply: 'Apply',
    userCreateConfirmation: 'Create new local user?',
    userGroupCreateConfirmation: 'Do you want to create new user group?',
    createUserSuccessful: 'Local user created',
    profileEditPrompt: 'Do You want to change profile details?',
    PermissionEditPrompt: 'Do You want to change user permissions?',
    RevokePromptTitle: 'Do You want to revoke user?',
    RevokePromptPlaceholder: 'Comment on revoking the user',
    ActivatePrompt: 'Do You want to activate user',
    userPasswordRequirement: {
      0: 'Password must contain at least 8 characters',
      1: 'Password must contain numbers',
      2: 'Password must contain uppercase letters',
      3: 'Password must contain symbols'
    },
    userLoginRequirement: {
      0: 'Login can contain latin letters',
      1: 'Login can contain numbers',
      2: 'Login can contain characters \'.\', \'_\' ',
      3: 'Login must start and end with letters or numbers',
      4: 'Login can contain 32 characters'
    },
    changePassword: 'Change password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    password: 'Password',
    confirmPassword: 'Confirm password',
    confirmPasswordFail: 'Passwords don\'t match',
    passwordChanged: 'Password changed',
    createUserPrompt: 'Are You sure You want to add user',
    profile: 'Profile',
    InfoNotSet: 'You must set user information',
    userInformationUpdateSuccess: 'User information successfully updated.',
    userWithoutAvailableRoles: 'User does not have available roles defined'
  },
  userStatus: {
    1: 'Active',
    2: 'Inactive',
    3: 'Deactivated'
  },
  rowStatus: {
    active: 'Active',
    inactive: 'Inactive'
  },
  validation: {
    nameRequired: 'Name is required',
    usernameRequired: 'Username is required',
    emailRequired: 'Email is required',
    claimRequired: 'You must asign at least one claim or role to user',
    usernameTooLong: 'Username can\'t have more than 32 characters',
    repeatMustMatch: 'Passwords must match',
    oldPasswordRequired: 'Old password missing',
    password: {
      0: 'Password must contain at least 8 characters',
      1: 'Password must contain numbers',
      2: 'Password must contain capital letters',
      3: 'Password must contain special characters'
    }
  },
  subscribe: {
    title: 'Subscribe',
    subscribedFilters: 'Subscribed filters',
    newFilterSubscription: 'New filter subscription',
    filtersForSubscription: 'Filters for subscription',
    NoSubscriptions: 'You have no subscriptions',
    headers: 'Header',
    parameters: 'Parameters',
    key: 'Key',
    value: 'Value',
    URL: 'Receiver Web address',
    subscribe: 'Subscibe',
    urlRequired: 'Field is required',
    urlInvalidFormat: 'Invalid field format',
    filtersEmpty: 'None of the filters are selected',
    headerEmpty: 'Invalid input of headers',
    parameterEmpty: 'Invalid input of parameters',
    success: 'Successfully subscribed',
    review: 'Subscribe review',
    basicInfo: 'Subscribe basic info',
    unsubscribe: 'Unsubscribe',
    confirmUnsubscribe: 'Are you sure you want to unsubscribe from data table ',
    unsubscribeSuccessful: 'Successfully unsubscribed from data table',
    updateSuccessful: 'Successfully updated data table'
  }
}
